module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-"
  }, [_vm._v("To Michael, Holly, Terry, Leroy, Sue, for believing in the starship before it existed;")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-"
  }, [_vm._v("To Ryan for the video and Steve for the t-shirts; and, of course, To Majel and Gene for encouragement at the airport.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4862604","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Starfarers_1245.vue
// module id = 75
// module chunks = 0